import { fetchAuthSession } from 'aws-amplify/auth';
import { AuthStorage } from './types';
import { logger } from '../../../utils/logger';

export class TokenService implements AuthStorage {
  private static instance: TokenService;
  private token: string | null = null;

  private constructor() {}

  static getInstance(): TokenService {
    if (!TokenService.instance) {
      TokenService.instance = new TokenService();
    }
    return TokenService.instance;
  }

  async getToken(): Promise<string | null> {
    try {
      // Return cached token if available
      if (this.token) {
        return this.token;
      }

      const session = await fetchAuthSession();
      if (!session.tokens?.accessToken) {
        return null;
      }

      if (!session.tokens?.idToken) throw new Error('No idToken available');

      this.token = session.tokens?.idToken.toString();
      return this.token;
    } catch (error) {
      logger.error('Failed to get auth token:', error);
      return null;
    }
  }

  clearToken(): void {
    this.token = null;
  }

  async refreshToken(): Promise<string | null> {
    this.clearToken();
    return this.getToken();
  }
}

// Export singleton instance
export const tokenService = TokenService.getInstance();
